
export function getBookmakerName(channelName) {

    const channelToBookmaker = {
        "betpt": "betpt",
        "betano": "betano",
        "betfair": "betfair",
        "betfair live video": "betfair",
        "bet365": "bet365",
        "betclic": "betclic",
        "10bet": "10bet",
        "betathome": "betathome",
        "melbet": "melbet",
        "mellbet": "melbet",
        "royrichie": "royrichie",
        "1xbet": "1xbet",
        "williamhill": "williamhill",
    };
    const nameLowerCase = channelName.toLowerCase();
    let result = channelToBookmaker[nameLowerCase];
    if (typeof result === "undefined") {
        result = 0;
    }
    return result;
}